import { useCallback } from 'react';

import {
  type AIJobNotificationContext,
  getTrackingKey,
  useAIJobNotificationStore,
} from 'stores/aiJobNotificationStore';

type TrackAIJobInput = Omit<AIJobNotificationContext, 'createdAt'>;

export const useTrackAIJob = () => {
  const { trackAIJob, trackedJobs } = useAIJobNotificationStore();

  const startTracking = useCallback(
    (context: TrackAIJobInput) => {
      const fullContext: AIJobNotificationContext = {
        ...context,
        createdAt: new Date(),
      };

      // The AIJobNotificationManager will detect this and manage notifications
      trackAIJob(fullContext);
    },
    [trackAIJob]
  );

  const isTracking = useCallback(
    (context: Pick<AIJobNotificationContext, 'jobbableId' | 'jobType'>) => {
      return trackedJobs.has(getTrackingKey(context));
    },
    [trackedJobs]
  );

  return { startTracking, isTracking };
};
